import { Attachment } from '../../graphql/graphql';

export const messageCaption = (text: string, attachments: Attachment[]): string => {
  if (attachments.length === 0) return text;
  if (text === 'attachment') return '';

  // Older clients used the upload's ID or file name as the message text.
  const isFileReference = attachments.some((attachment) => {
    if (text === attachment.uploadId) return true;

    return [attachment.url, attachment.thumbnailUrl].some((url) => {
      const fileName = url.split('?')[0].split('/').pop() ?? '';
      return fileName === text || fileName.replace(/\.[^.]+$/, '') === text;
    });
  });

  return isFileReference ? '' : text;
};
